export default __webpack_public_path__ + "static/media/poor.25d86a5a.png";